import React from 'react';
import { Column, Row, Title } from '@ydistri/ds';
import DeadStockTypeDefinition from './components/DeadStockTypeDefinition';
import SlowMoversTypeDefinition from './components/SlowMoversTypeDefinition';
import FastMoversTypeDefinition from './components/FastMoversTypeDefinition';
import { Spin } from 'antd';
import useIsConfigurationEditable from '../../../../hooks/useIsConfigurationEditable';

interface CategoryInventoryDefinitionSectionProps {
  fetching?: boolean;
}

const CategoryInventoryDefinitionSection: React.FC<CategoryInventoryDefinitionSectionProps> = ({
  fetching,
}) => {
  const isConfigurationEditable = useIsConfigurationEditable();

  return (
    <Column $gap="16px" $minWidth="760px">
      <Title $size="large">Inventory type definition</Title>
      <Spin spinning={fetching}>
        <Row $flexWrap="nowrap">
          <DeadStockTypeDefinition disabled={!isConfigurationEditable} />
          <SlowMoversTypeDefinition disabled={!isConfigurationEditable} />
          <FastMoversTypeDefinition />
        </Row>
      </Spin>
    </Column>
  );
};

export default CategoryInventoryDefinitionSection;
